<div class="forgot-root">
  <div class="forgot-columns">
    <div class="forgot-image-col" aria-hidden="true">
      <app-auth-hero-panel [hero]="hero" />
    </div>
    <div class="forgot-form-col">
      <div class="forgot-form-wrapper">
        <div class="logo-container">
          <img src="assets/icons/aio-logo-black.svg" alt="Logo" class="forgot-logo" />
        </div>

        @if (!emailSent) {
          <div class="forgot-header">
            <h2 class="forgot-title">Forgot your password?</h2>
            <p class="forgot-subtext">Enter the email address linked to your account.</p>
          </div>

          @if (errorMessage) {
            <div class="error-message" role="alert">
              {{ errorMessage }}
            </div>
          }

          <form class="forgot-form" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
            <div class="form-group">
              <label for="email" class="form-label">Email Address</label>
              <div class="input-icon-group">
                <input
                  id="email"
                  name="email"
                  type="email"
                  class="form-input"
                  [class.input-error]="submitted && f['email'].errors"
                  placeholder="name@example.com"
                  formControlName="email"
                  required
                />
              </div>
              @if (submitted && f['email'].errors) {
                <div class="field-error">
                  @if (f['email'].errors['required']) {
                    Email address is required
                  }
                  @if (f['email'].errors['email']) {
                    Please enter a valid email address.
                  }
                </div>
              }
            </div>
            <aio-button [block]="true" appearance="brand" size="lg" type="submit" [disabled]="loading" class="forgot-button">
              @if (loading) {
                <span class="button-spinner"></span>
                Sending…
              } @else {
                Send Reset Link
              }
            </aio-button>
          </form>

          <aio-button [block]="true" appearance="neutral-stroke" size="lg" type="button" class="back-to-login-button" (pressed)="onBackToLogin()">
            <svg class="back-arrow-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M19 12H5"/>
              <path d="m12 19-7-7 7-7"/>
            </svg>
            Back to Login
          </aio-button>
        } @else {
          <div class="inbox-confirmation">
            <div class="success-icon-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke="#22c55e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M22 4L12 14.01l-3-3" stroke="#22c55e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h2 class="inbox-title">Check your inbox</h2>
            <p class="inbox-text">
              If an account exists for <span class="inbox-email">{{ submittedEmail }}</span>, you'll receive a password reset link shortly.
            </p>
            <p class="inbox-text">The link expires in 1 hour.</p>
            <p class="inbox-hint">
              Didn't receive it? Check your spam folder or
              <button type="button" class="try-again-link" [disabled]="loading" (click)="onTryAgain()">try again</button>.
            </p>
            <aio-button [block]="true" appearance="neutral-stroke" size="lg" type="button" class="back-to-login-button" (pressed)="onBackToLogin()">
              <svg class="back-arrow-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M19 12H5"/>
                <path d="m12 19-7-7 7-7"/>
              </svg>
              Back to Login
            </aio-button>
          </div>
        }
      </div>
      <app-auth-footer></app-auth-footer>
    </div>
  </div>
</div>
